// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BorrowLimitHubViewCtaBulletEvent
 */
export var BorrowLimitHubViewCtaBullet = function (_a) {
    var identifier = _a.identifier, sectionIdentifier = _a.sectionIdentifier;
    return ({
        name: "BorrowLimitHub View CtaBullet",
        parameters: {
            cdf_entity: "BorrowLimitHub",
            cdf_action: "View",
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section_identifier: sectionIdentifier !== undefined && sectionIdentifier !== null ? sectionIdentifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowLimitHubViewSeeSectionEvent
 */
export var BorrowLimitHubViewSeeSection = function (_a) {
    var source = _a.source;
    return ({
        name: "BorrowLimitHub View SeeSection",
        parameters: {
            cdf_entity: "BorrowLimitHub",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowLimitHubViewBulletinSheetEvent
 */
export var BorrowLimitHubViewBulletinSheet = function (_a) {
    var identifier = _a.identifier;
    return ({
        name: "BorrowLimitHub View BulletinSheet",
        parameters: {
            cdf_entity: "BorrowLimitHub",
            cdf_action: "View",
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BorrowLimitHubInteractTapCtaBulletEvent
 */
export var BorrowLimitHubInteractTapCtaBullet = function (_a) {
    var identifier = _a.identifier, routeUrl = _a.routeUrl;
    return ({
        name: "BorrowLimitHub Interact TapCtaBullet",
        parameters: {
            cdf_entity: "BorrowLimitHub",
            cdf_action: "Interact",
            identifier: identifier !== undefined && identifier !== null ? identifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            route_url: routeUrl !== undefined && routeUrl !== null ? routeUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
